<template>
  <div class="modal vc_modal my_account_modal show" :class="size">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content my_account_modal_content p_0">
        <button type="button" class="btn-close" @click="closeModal()"></button> 
        <div class="modal-body p_0">
          <h5 class="common_subtitle pb_15 font_18p border-lightgray-bottom pt_15 pl_15">{{ title }}</h5>
          <div class="p_20">
            <slot/>
          </div>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: ['title', 'closeModal', 'size']
}
</script>
<style scoped>
    .modal{
        background-color: rgb(0 0 0 / 15%);
    }
</style>